module.exports = "/static/assets/ad093676c5c19839d4e72ed843e2a281.png";